<template>
  <div id="home">
    <div id="top">
      <img src="images/AAV/homeTop.png" alt="">
    </div>
    <div id="tabs">
      <div class="tab">
        <p @click="tabIndex=0">代办流程</p>
        <p @click="tabIndex=1">所需资料</p>
        <p @click="tabIndex=2">常见问题</p>
      </div>
      <div class="tab-bg">
        <div class="tab-on" :style="`left: ${1+tabIndex*33}%`"></div>
      </div>
    </div>
<!--    tab-view-->
    <div>
<!--      代办流程-->
      <div id="tab-view" v-if="tabIndex===0">
        <div class="title">代办流程</div>
        <div class="content">
          <div class="left">
            <div>传统代办流程</div>
            <div class="left-list">
              <div>准备年检资料</div>
              <div>前往车管所</div>
              <div>窗口排队交钱</div>
              <div>提交资料</div>
              <div>民警受理</div>
              <div>审核资料</div>
              <div>签发标志</div>
              <div>办理完成</div>
            </div>
          </div>
          <div class="right">
            <div>优能代办流程</div>
            <div class="right-list">
              <div>上传资料照片</div>
              <div>专人上门收取资料</div>
              <div>办理完成</div>
              <div>线上缴费</div>
            </div>
          </div>
        </div>
      </div>
<!--      所需资料-->
      <div id="tab-view" v-if="tabIndex===1">
        <div class="title">所需资料</div>
        <div class="show">
          <div class="show-item">
            <p>身份证</p>
            <div><img style="height: 29.6vw;" src="images/AAV/example1.png" alt=""></div>
          </div>
          <div class="show-item">
            <p>行驶证</p>
            <div><img style="width: 21.067vw;" src="images/AAV/example2.png" alt=""></div>
          </div>
          <div class="show-item">
            <p>驾驶证</p>
            <div><img style="width: 21.067vw;" src="images/AAV/example3.png" alt=""></div>
          </div>
          <div class="show-item">
            <p>有效期内的交强险保单</p>
            <div><img style="width: 43.2vw;" src="images/AAV/example4.png" alt=""></div>
          </div>
        </div>
      </div>
<!--      常见问题-->
      <div id="tab-view" v-if="tabIndex===2">
        <div class="title">常见问题</div>
        <div class="q-a">
          <van-collapse v-model="collapseIndex" accordion>
            <van-collapse-item title="年检可以提前办理吗?" name="1">
              机动车在年审日前的3个月，都可接受检测申请年审。最好提前两个月或1个多月，别等到距离年检到期只剩不几天才想起受检。其次，每月10日前，检测站业务量相对偏少，是过线免排队的良机。
            </van-collapse-item>
            <van-collapse-item title="标题2" name="2">内容</van-collapse-item>
            <van-collapse-item title="标题3" name="3">内容</van-collapse-item>
          </van-collapse>
        </div>
      </div>
    </div>
<!--    平台优势-->
    <div id="advantage">
      <div class="title">平台优势</div>
      <div class="content">
        <div class="content-item">
          <img src="images/AAV/homeIcon1.png" alt="">
          <div class="text">
            <p>专人跟进</p>
            <p>专人解决您的年检问题</p>
          </div>
        </div>
        <div class="content-item">
          <img src="images/AAV/homeIcon2.png" alt="">
          <div class="text">
            <p>上门服务</p>
            <p>线上预约 足不出门</p>
          </div>
        </div>
        <div class="content-item">
          <img src="images/AAV/homeIcon3.png" alt="">
          <div class="text">
            <p>省时快捷</p>
            <p>省时省心 极速办理</p>
          </div>
        </div>
        <div class="content-item">
          <img src="images/AAV/homeIcon4.png" alt="">
          <div class="text">
            <p>服务透明</p>
            <p>价格透明 消费更放心</p>
          </div>
        </div>
      </div>
    </div>
    <div id="button">
      <div @click="toReserve">年审预约</div>
      <div @click="toOrderList">
        <p>我的订单</p>
        <img src="images/AAV/rightArrows.png" alt="">
      </div>
    </div>
    <div id="bottom">
      <ServiceTel/>
    </div>
  </div>
</template>

<script>
  import ServiceTel from "../widget/serviceTel";

  export default {
    name: "index",
    components:{
      ServiceTel,
    },
    data() {
      return {
        tabIndex: 0, // tabs当前下标
        collapseIndex: '1',
      }
    },
    methods:{
      toReserve() {
        this.$router.push('/AAV/reserve')
      },
      toOrderList() {
        this.$router.push('/AAV/orderlist')
      }
    },
    mounted() {
      setInterval(() => {
        console.log()
      })
    }
  }
</script>

<style scoped>
  #top{
    width: 92vw;
    margin: 2.667vw auto 0;
  }
  #top>img{width: 100%}
  #tabs{
    width: 92vw;
    height: 6.667vw;
    background: #f5f7fa;
    border-radius: 3.333vw;
    margin: 4vw auto 0;
    position: relative;
  }
  .tab{
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 3.2vw;
    color: #303133;
    position: relative;
    z-index: 1;
  }
  .tab>p{
    flex: 1;
    height: 6.667vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }
  .tab-bg{
    width: 99%;
    height: 6.667vw;
    margin: 0 auto;
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
  }
  .tab-on{
    width: 33.3333333%;
    height: 5.6vw;
    background-color: #ffffff;
    box-shadow: 0vw 0vw 1.333vw 0vw
    rgba(191, 194, 204, 0.5);
    border-radius: 2.667vw;
    position: absolute;
    transition: all 300ms;
  }
  #tab-view{
    width: 92vw;
    margin: 3.333vw auto;
    background-color: #ffffff;
    box-shadow: 0vw 0vw 0.8vw 0vw
    rgba(144, 147, 153, 0.38);
    border-radius: 0.8vw;
  }
  #tab-view>.title{
    width: 84.133vw;
    height: 10.533vw;
    margin: 0.8vw auto 0;
    border-bottom: 1px solid #edeff2;
    font-size: 3.733vw;
    color: #303133;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  #tab-view>.content{
    margin: 4.4vw 3.6vw 0;
    display: flex;
  }
  #tab-view .left{flex: 1;margin-right: 3.733vw}
  #tab-view .right{flex: 1;margin-left: 3.733vw}
  #tab-view .left>div:first-child{
    width: 100%;
    height: 6.667vw;
    background-color: #bfc2cc;
    border-radius: 3.333vw;
    font-size: 3.733vw;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  #tab-view .right>div:first-child{
    width: 100%;
    height: 6.667vw;
    background-color: #00d10b;
    border-radius: 3.333vw;
    font-size: 3.733vw;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  #tab-view .left-list{position: relative;margin: 4vw 0 0 8vw;}
  #tab-view .left-list>div{
    height: 8.533vw;
    font-size: 3.2vw;
    position: relative;
  }
  #tab-view .left-list>div:before{
    content: '';
    width: 3.2vw;
    height: 3.2vw;
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: -5.2vw;
    background-color: #bfc2cc;
  }
  #tab-view .left-list>div:after{
    content: '';
    width: 0.533vw;
    height: 5.333vw;
    background-color: #bfc2cc;
    position: absolute;
    top: 3.2vw;
    left: -3.866vw;
  }
  #tab-view .left-list>div:last-child::after{content: '';position: relative;}
  #tab-view .right-list{position: relative;margin: 4vw 0 0 8vw;}
  #tab-view .right-list>div{
    height: 8.533vw;
    font-size: 3.2vw;
    position: relative;
  }
  #tab-view .right-list>div:before{
    content: '';
    width: 3.2vw;
    height: 3.2vw;
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: -5.2vw;
    background-color: #00d10b;
  }
  #tab-view .right-list>div:after{
    content: '';
    width: 0.533vw;
    height: 5.333vw;
    background-color: #00d10b;
    position: absolute;
    top: 3.2vw;
    left: -3.866vw;
  }
  #tab-view .right-list>div:last-child::after{content: '';position: relative;}
  #tab-view>.show{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 2.133vw 5.467vw;
  }
  #tab-view .show-item>p{
    font-size: 3.467vw;
    color: #303133;
    margin: 4.5vw 0 2.667vw;
  }
  #tab-view .show-item>div{
    width: 43.2vw;
    height: 32.267vw;
    background-color: #f5f7fa;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  #advantage{padding: 4vw;}
  #advantage>.title{font-size: 4vw;color: #303133;margin-left: 2.267vw;position: relative}
  #advantage>.title::before{
    content: '';
    position: absolute;
    left: -1.7vw;
    width: 0.8vw;
    height: 4vw;
    background-color: #48e691;
  }
  #advantage>.content{
    display: flex;
    flex-wrap: wrap;
  }
  #advantage .content-item{
    width: 50%;
    margin: 6vw 0 0;
    display: flex;
  }
  #advantage .content-item>img{
    width: 7.467vw;
    height: 7.467vw;
    object-fit: contain;
  }
  #advantage .text{margin-left: 2vw;}
  #advantage .text>p:first-child{
    font-size: 3.733vw;
    color: #000000;
  }
  #advantage .text>p:last-child{
    font-size: 3.2vw;
    color: #909399;
    margin-top: 1vw;
  }
  #button>div:first-child{
    width: 88.267vw;
    height: 11.733vw;
    background-color: #2794eb;
    border-radius: 1.067vw;
    margin: 3vw auto 0;
    font-size: 4.267vw;
    color: #fefefe;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  #button>div:last-child{
    height: 14vw;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 4vw;
    color: #909399;
  }
  #button img{
    width: 1.867vw;
    height: 3.2vw;
    margin-left: 1.5vw;
  }
</style>
